import { Box, Button, customStyled, Flex, variant } from '@mafc/trolly';
import COLORS from 'theme/colors';

export enum CartListItemVariant {
  Default = 'default',
  OOS = 'oos',
  DrawerHeader = 'drawer_header',
  DrawerItem = 'drawer_item',
}

export const CartListItem = customStyled(Box)<{ isExpressProduct: boolean; isCampaign?: boolean }>(
  props => ({
    padding: `16px 16px 20px`,
    position: 'relative',
    background: 'transparent',
    marginBottom: props.isCampaign ? 0 : props.theme.space[3],
    borderRadius: props.isCampaign ? 0 : props.theme.radii[3],
  }),
  ({ theme, isExpressProduct, isCampaign }) =>
    variant({
      variants: {
        [CartListItemVariant.Default]: {
          background: isCampaign ? 'transparent' : theme.colors.white,
        },
        [CartListItemVariant.OOS]: {
          border: `1px solid ${theme.colors.lightGray}`,
        },
        [CartListItemVariant.DrawerHeader]: {
          borderBottom: `1px solid ${theme.colors.lightGray}`,
          borderRadius: 0,
          paddingBottom: isExpressProduct ? `${theme.space[4]}px` : `${theme.space[2]}px`,
        },
        [CartListItemVariant.DrawerItem]: {
          marginBottom: isExpressProduct ? `${theme.space[2]}px` : `-${theme.space[1]}px`,
          borderRadius: 0,
          padding: `${theme.space[2]}px ${theme.space[1]}px`,
          width: '100%',
        },
      },
    })
);

export const Product = customStyled(Flex)(() => ({
  alignItems: 'start',
}));

export const PriceAndQuantityRow = customStyled(Flex)(props => ({
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const CartListItemNameLink = customStyled(Box)(props => ({
  color: 'unset',
  textDecoration: 'none',
  textTransform: 'capitalize',
  display: 'block',
  fontSize: props.theme.fontSizes[1],
  marginBottom: '6px',
}));

export const OOSItemRow = customStyled(Flex)(() => ({
  justifyContent: 'end',
}));

export const ProductDetails = customStyled(Flex)(() => ({
  flexDirection: 'column',
  width: '100%',
}));

export const ExtendedWarranty = customStyled(Box)(() => ({
  marginTop: '16px',
}));

export const RemoveOOSItemBtn = customStyled(Button)(props => ({
  fontSize: props.theme.fontSizes[2],
  fontWeight: props.theme.fontWeights[6],
  height: 'auto',
  padding: '10px 24px',
  textTransform: 'none',
  borderRadius: props.theme.radii[4],
  lineHeight: '20px',
}));

export const SharePriceBadge = customStyled(Box)(props => ({
  background: COLORS.MAGENTA,
  width: 'max-content',
  padding: '2px 6px',
  borderRadius: '2px',
  fontSize: '11px',
  color: COLORS.WHITE,
  fontWeight: props.theme.fontWeights[6],
  marginBottom: '8px',
}));
